import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_11_04() {
  return (
    <NoteContainer date={'04/11/2025'} version="20.17.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Integração com whatsapp</TaskTitle>
                <TaskBreadcrumb>Geral</TaskBreadcrumb>
                <TaskDescription>Agora é possível notificar cidadãos e agentes públicos via whatsapp</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>

        <ModuleContainer moduleName="VULNERABILITY_ALERTS">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Integração com whatsapp: criação do alerta</TaskTitle>
                <TaskBreadcrumb>Alertas</TaskBreadcrumb>
                <TaskDescription>
                  Agora é possível adicionar números de whatsapp para notificar criações de alertas
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle important={true}>Integração com whatsapp: monitoramento do alerta</TaskTitle>
                <TaskBreadcrumb>Alertas/ Perfil do Alerta/ Monitoramento</TaskBreadcrumb>
                <TaskDescription>
                  Agora é possível adicionar números de whatsapp para notificar monitoramentos de alertas
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento', 'agsus']}>
          <ModuleContainer moduleName="APP_CITIZEN">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Mensagens específicas na consulta de holerite</TaskTitle>
                  <TaskBreadcrumb>Perfil/ Consultar holerite</TaskBreadcrumb>
                  <TaskDescription>
                    Mensagem informando o usuário quando existe o holerite ou se existe algum problema com a consulta a
                    base do SIP
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>
      </VStack>
    </NoteContainer>
  )
}
